export default {"src":"/_next/static/media/Columbia.82b38c4a.svg","height":124,"width":143,"blurWidth":0,"blurHeight":0};